import React, { useState } from 'react';
import { TableContainer, Table, TableBody, TableHead, TableRow, TableCell, Tab, Tabs, Collapse, Paper } from '@mui/material';

const CampaignContactData = ({ contact }) => {
    const [tab, setTab] = useState('details');

    const opens = contact.opens?.length ?? 0;
    const clicks = contact.clicks?.length ?? 0;

    return (
        <>
            <Tabs value={tab} onChange={(e, value) => setTab(value)}>
                <Tab value="details" label="Send Details" />
                <Tab value="bounce" label="Delivery Details" disabled={!contact.bounced} />
                <Tab value="opens" label="Open Times" disabled={opens === 0} />
                <Tab value="clicks" label="Links Clicked" disabled={clicks === 0} />
            </Tabs>
            <Paper variant="outlined">
                <Collapse in={tab === 'details'}>
                    <TableContainer>
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" width="50%">
                                        Send Status:
                                    </TableCell>
                                    <TableCell>
                                        {contact.sendStatus}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th">
                                        Send Time:
                                    </TableCell>
                                    <TableCell>
                                        {contact.dateTimeSent ? new Date(contact.dateTimeSent).toLocaleString('en-GB') : ''}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th">
                                        Number of Opens:
                                    </TableCell>
                                    <TableCell>
                                        {opens}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th">
                                        Number of Clicks:
                                    </TableCell>
                                    <TableCell>
                                        {clicks}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Collapse>
                <Collapse in={tab === 'bounce'}>
                    <TableContainer>
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th">
                                        Delivery Status:
                                    </TableCell>
                                    <TableCell>
                                        {contact.deliveryStatus}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th">
                                        Bounce Category:
                                    </TableCell>
                                    <TableCell>
                                        {contact.bounceCategory}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th">
                                        Bounce Message:
                                    </TableCell>
                                    <TableCell>
                                        {contact.bounceMessage}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Collapse>
                <Collapse in={tab === 'opens'}>
                    <TableContainer>
                        <Table size="small">
                            <TableBody>
                                {contact.opens.map((open, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {new Date(open.dateTime).toLocaleString('en-GB')}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Collapse>
                <Collapse in={tab === 'clicks'}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th">
                                        URL
                                    </TableCell>
                                    <TableCell component="th">
                                        Clicks
                                    </TableCell>
                                    <TableCell component="th">
                                        1st Click
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {contact.clicks.map((click, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {click.url}
                                        </TableCell>
                                        <TableCell>
                                            {click.count}
                                        </TableCell>
                                        <TableCell>
                                            {new Date(click.dateTime).toLocaleString('en-GB')}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Collapse>
            </Paper>
        </>
    );
};

export default CampaignContactData;